import { observable } from 'mobx';
import {
    AnimationOrientation,
    ExtraPostDataOptions,
    PostTextFormat,
} from '@sprinklr/stories/widget/types';
import {
    GridLayoutImpl,
    NativeStylingOptionsDefaultImpl,
    PostsWidgetOptions,
    PostsWidgetOptionsImpl,
} from '../options';

export class PostCardWidgetOptionsImpl extends PostsWidgetOptionsImpl
    implements PostsWidgetOptions {
    @observable extraPostDataOptions: ExtraPostDataOptions = {
        enabled: true,
        color: '',
        size: 20,
        value: {
            format: '1.23k',
        },
        border: {
            enabled: true,
            color: '',
        },
        header: {
            enabled: true,
            size: 30,
            text: 'Additional Details',
            color: '',
        },
        dateFormat: 'dddd, MMMM Do YYYY',
    };
    @observable showEngagementMetrics = false;
    @observable showAdsMetrics = false;
    @observable textOnlyTextFormat: PostTextFormat = 'clamp';
    @observable postImageTextFormat: PostTextFormat = 'clamp';
    @observable classes = 'rel';
    @observable postLineClampValue = 7;
    @observable postTextOnlySize = 18;
    @observable postImageTextSize = 13;
    @observable postComposition = 'a';
    @observable nativeStyling = new NativeStylingOptionsDefaultImpl();
    @observable gridLayout = new GridLayoutImpl();
    @observable animationOrientation: AnimationOrientation = 'horizontal';
}
